<template>
    <nav class="navMenu">
      <router-link class="navBar" to="/">
        <svg class="icon" viewBox="0 0 150 150">
          <polygon
            class="house door left"
            points="125.31074, 72.65486 
                      125.31074, 136.30609 
                      86.00762, 136.30609 
                      86.00762, 97.72275 
                      64.20571, 97.72275 
                      64.20571, 136.30609 
                      23.16926, 136.30609 
                      23.16926, 72.65486 
                      74.24,    33.37175"/>
            <polygon
            class="house roof left"
            points=" 17.07357,   89.50328
                      1.52,       69.2868
                      74.24,      12.17391
                      148.48,     69.2868
                      132.92643,  89.50328
                      74.24,      44.35811
                      "/>
            <polygon
            class="house door right"
            points="125.31074, 72.65486
                      125.31074,136.30609
                      86.00762, 136.30609
                      86.00762, 97.72275
                      74.24,    97.72275
                      74.24,    33.37175"/>
            <polygon
            class="house roof right"
            points=" 148.48,     69.2868
                      132.92643,  89.50328
                      74.24,      44.35811
                      74.24,      12.17391
                      105.94222,  36.56262
                      105.94222,  26.18874
                      127.45065,  26.18874
                      127.45065,  53.10915"/>
        </svg>
        <div class="navTitle">Home</div>
      </router-link>
      <router-link class="navBar" to="/research">
        <svg class="icon" viewBox="-15 0 170 150">
            <rect
              class="research paper"
              width="94.107025"
              height="132.0486"
              x="0.93753248"
              y="17.875311"
              ry="5.9910288" />
            <rect
              class="research graph left"
              width="17.92519"
              height="48.397812"
              x="10.647022"
              y="91.137428"
              ry="1.1251483" />
            <rect
              class="research graph middle"
              width="17.92519"
              height="66.323006"
              x="38.729752"
              y="73.212242"
              ry="1.5418717" />
            <rect
              class="research graph right"
              width="17.92519"
              height="59.750439"
              x="67.409882"
              y="79.784798"
              ry="1.3890731" />
            <path
              class="research typed"
              d="m 14.115653,29.918062 h 65.95317"
              />
            <path
              class="research typed"
              d="m 14.115653,39.851765 h 65.95317"
              />
            <path
              class="research typed"
              d="m 14.115653,49.785457 h 65.95317"
              />
            <path
              class="research typed"
              d="M 14.115653,59.719164 H 31.17094"
              />
            <path
              class="research graph left cover"
              d="m 19.609472,91.13743 v 48.39781 h 7.80245 c 0.64061,0 1.16,-0.51939 1.16,-1.16 V 92.29743 c 0,-0.64061 -0.51939,-1.16 -1.16,-1.16 z"
              />
            <path
              class="research graph middle cover"
              d="m 47.692202,73.21224 v 66.323 h 7.80245 c 0.640611,0 1.160001,-0.51939 1.160001,-1.16 v -64.003 c 0,-0.64061 -0.51939,-1.16 -1.160001,-1.16 z"
              />
            <path
              class="research graph right cover"
              d="m 76.372622,79.7848 v 59.75044 h 7.80245 c 0.64061,0 1.16,-0.51939 1.16,-1.16 V 80.9448 c 0,-0.64061 -0.51939,-1.16 -1.16,-1.16 z"
              />
            <path
              class="research magnify handle"
              d="M 143.20465,108.63577 116.54431,81.267637"
              />
            <circle
              class="research magnify border"
              cx="91.489738"
              cy="47.577347"
              r="47.501251" />
            <circle
              class="research magnify glass"
              cx="91.489738"
              cy="47.577347"
              r="38.521133" />
            <path
              class="research magnify reflect"
              d="M 118.74104,20.3261 C 110.0886,11.67366 98.311703,8.00487 87.008372,9.31683 c 8.32648,0.96657 16.396018,4.63536 22.769928,11.00927 15.02635,15.02635 15.02635,39.47596 0,54.5026 -6.37391,6.37391 -14.443448,10.0427 -22.769928,11.00927 11.30333,1.31196 23.080228,-2.35683 31.732668,-11.00927 15.02635,-15.02635 15.02635,-39.47625 0,-54.5026 z"
              />
        </svg>
        <div class="navTitle">Research</div>
      </router-link>
      <router-link class="navBar" to="/people">
        <svg class="icon" viewBox="-10 0 170 150">
            <path
              class="people far right body"
              d="M 127.82698,79.977115 H 112.7551 c -11.80851,0 -21.47943,9.62917 -21.47943,21.437675 v 23.6379 c 0,7.08498 5.82813,12.88876 12.91341,12.88876 H 136.393 c 7.08528,0 12.847,-5.80378 12.847,-12.88875 v -23.63791 c 0,-11.808795 -9.60451,-21.437675 -21.41302,-21.437675 z"
              />
            <path
              class="people close right body"
              d="m 120.29104,79.976835 h -7.53594 c -11.80851,0 -21.47943,9.62916 -21.47943,21.437665 v 23.6379 c 0,7.08498 5.82813,12.88875 12.91341,12.88875 h 16.10196 z"
              />
            <path
              class="people far right head"
              d="m 120.29104,36.063875 c -10.62067,0 -19.26093,8.64055 -19.26093,19.26092 0,10.62067 8.64026,19.26123 19.26093,19.26123 10.62067,0 19.26093,-8.64056 19.26093,-19.26123 0,-10.62008 -8.64026,-19.26092 -19.26093,-19.26092 z"
              />
            <path
              class="people close right head"
              d="m 120.29104,36.063875 c -10.62067,0 -19.26093,8.64055 -19.26093,19.26092 0,10.62067 8.64026,19.26123 19.26093,19.26123 z"
              />
            <path
              class="people close left body"
              d="M 37.31102,79.977115 H 22.23943 C 10.43092,79.977115 0.76,89.605995 0.76,101.4145 v 23.6379 c 0,7.08499 5.82813,12.88875 12.91341,12.88875 h 32.20392 c 7.08528,0 12.847,-5.80376 12.847,-12.88875 v -23.6379 c 0,-11.808505 -9.60451,-21.437385 -21.41331,-21.437385 z"
              />
            <path
              class="people far left body"
              d="M 29.77537,79.976835 H 22.23943 C 10.43092,79.976835 0.76,89.605995 0.76,101.4145 v 23.6379 c 0,7.08498 5.82813,12.88875 12.91341,12.88875 h 16.10196 c 0,3e-4 0,-57.964315 0,-57.964315 z"
              />
            <path
              class="people center right body"
              d="M 88.11438,68.842275 H 61.88562 c -11.80851,0 -21.41534,9.60683 -21.41534,21.41535 V 133.6187 c 0,2.36553 1.91777,4.28301 4.28301,4.28301 h 60.49342 c 2.36553,0 4.28301,-1.91748 4.28301,-4.28301 V 90.257625 c 0,-11.80852 -9.60683,-21.41535 -21.41534,-21.41535 z"
              />
            <path
              class="people center left body"
              d="M 75.14471,68.842275 H 61.88562 c -11.80851,0 -21.41534,9.60683 -21.41534,21.41535 V 133.6187 c 0,2.36553 1.91777,4.28301 4.28301,4.28301 h 30.39142 z"
              />
            <path
              class="people center right head"
              d="m 75,12.058545 c -14.2013,0 -25.7549,11.55359 -25.7549,25.7549 0,14.2013 11.55331,25.75489 25.7549,25.75489 14.20159,0 25.7549,-11.55359 25.7549,-25.75489 0,-14.20131 -11.5536,-25.7549 -25.7549,-25.7549 z"
              />
            <path
              class="people center left head"
              d="m 75,12.058545 c -14.2013,0 -25.7549,11.55359 -25.7549,25.7549 0,14.2013 11.55331,25.75489 25.7549,25.75489 z"
              />
            <path
              class="people close left head"
              d="m 29.77537,36.063875 c -10.62067,0 -19.26093,8.64055 -19.26093,19.26092 0,10.62067 8.64026,19.26123 19.26093,19.26123 10.62067,0 19.26093,-8.64056 19.26093,-19.26123 0,-10.62008 -8.64026,-19.26092 -19.26093,-19.26092 z"
              />
            <path
              class="people far left head"
              d="m 29.77537,36.063875 c -10.62067,0 -19.26093,8.64055 -19.26093,19.26092 0,10.62067 8.64026,19.26123 19.26093,19.26123 z"
              />
        </svg>
        <div class="navTitle">People</div>
      </router-link>
      <router-link class="navBar" to="/publications">
        <svg class="icon" viewBox="0 0 150 150">
            <rect
              class="publication back"
              width="93.569923"
              height="131.50578"
              x="38.149998"
              y="-1.2909826"
              ry="7.2058144"
              transform="matrix(0.99437815,0.10588722,-0.10564626,0.99440378,0,0)" />
            <path
              class="publication front"
              d="M 18.100246,20.008456 V 139.40447 c 0,3.93119 2.982863,7.118 6.66246,7.118 h 85.071204 c 3.67959,0 6.66246,-3.18681 6.66246,-7.118 V 44.281979 L 87.113827,12.890465 H 24.762706 c -3.679597,0 -6.66246,3.186809 -6.66246,7.117991 z"
              />
            <path
              class="publication front shadow"
              d="m 93.531013,19.746151 v 29.5084 c 0,2.970441 2.253881,5.378166 5.033979,5.378166 h 4.677798 v 91.889753 h 6.59112 c 3.67959,0 6.66246,-3.18681 6.66246,-7.118 V 44.281979 Z"
              />
            <path
              class="publication front fold"
              d="M 87.113827,12.890465 116.49637,44.281979 H 92.148049 c -2.780097,0 -5.033979,-2.407986 -5.033979,-5.378166 V 12.890465 Z"
              />
            <path
              class="publication pen cap"
              d="m 128.53195,69.71582 -10.5972,11.16205 0.0692,0.07295"
              />
            <path
              class="publication pen shaft"
              d="m 117.74644,73.299698 -53.873783,57.557552 -6.861561,12.48598 c -1.027024,1.86876 0.943962,3.9745 2.693126,2.87726 l 11.686911,-7.33071 53.874017,-57.557546 c 0.88241,-0.942732 0.88241,-2.471148 0,-3.41388 l -4.32307,-4.618656 c -0.88265,-0.942732 -2.31325,-0.942732 -3.19564,0 z"
              />
            <path
              class="publication pen tip"
              d="m 59.703978,146.22023 11.686911,-7.33071 -7.518476,-8.03253 -6.861562,12.48597 c -1.026779,1.86903 0.943962,3.97451 2.693127,2.87727 z"
              />
            <path
              class="publication pen clip"
              d="m 108.55806,83.102159 5.04181,-5.386526 7.5172,8.031167 -5.04182,5.386529 z"
              />
              <path
                class="publication typed"
                d="m 30.008037,28.9 h 37.764818 v 0 0"
                />
              <path
                class="publication typed"
                d="m 30.008037,46.80552 h 37.764818 v 0 0"
                />
              <path
                class="publication typed"
                d="m 30.008037,64.75372 h 62 v 0 0"
                />
              <path
                class="publication typed"
                d="m 30.008037,83.39963 h 62 v 0 0"
                />
              <path
                class="publication typed"
                d="m 30.008037,100.6077 h 49.178639 v 0 0"
                />
              <path
                class="publication typed"
                d="m 30.008037,118.0425 h 35.358348 v 0 0"
                />
        </svg>
        <div class="navTitle">Publications</div>
      </router-link>
      <router-link class="navBar" to="/courses">
        <svg class="icon" viewBox="-10 0 170 150">
          <path
            class="books margins"
            d="m 141.05649,139.96 h -108.75 c -11.69193,0 -21.17,-9.47807 -21.17,-21.17 v -4.06 c 0,-11.69193 9.47807,-21.17 21.17,-21.17 h 108.75 z"
            />
          <rect
            class="books shadow"
            x="15.776489"
            y="98.199997"
            width="11.6"
            height="37.119999"
            />
          <path
            class="books margins"
            d="M 130.03649,86.6 H 6.49649 V 54.12 h 123.54 c 3.5235,0 6.38,2.8565 6.38,6.38 v 19.72 c 0,3.5235 -2.8565,6.38 -6.38,6.38 z"
            />
          <rect
            class="books margins"
            x="22.73649"
            y="12.36"
            width="118.32"
            height="34.799999"
            />
          <path
            class="books bottom"
            d="M 141.12,144.6 H 34.4 C 19.04914,144.6 6.56,132.11202 6.56,116.76 6.56,101.40798 19.04914,88.92 34.4,88.92 h 106.72 c 2.56244,0 4.64,2.07756 4.64,4.64 0,2.56244 -2.07756,4.64 -4.64,4.64 H 34.4 c -10.23381,0 -18.56,8.32619 -18.56,18.56 0,10.23381 8.32619,18.56 18.56,18.56 h 106.72 c 2.56244,0 4.64,2.07756 4.64,4.64 0,2.56244 -2.07756,4.64 -4.64,4.64 z"
            />
          <path
            class="books middle"
            d="M 127.2,88.92 H 4.24 c -1.28238,0 -2.32,-1.03762 -2.32,-2.32 0,-1.28238 1.03762,-2.32 2.32,-2.32 H 127.2 c 3.83786,0 6.96,-3.12214 6.96,-6.96 V 63.4 c 0,-3.83786 -3.12214,-6.96 -6.96,-6.96 H 4.24 c -1.28238,0 -2.32,-1.03762 -2.32,-2.32 0,-1.28238 1.03762,-2.32 2.32,-2.32 H 127.2 c 6.39595,0 11.6,5.20405 11.6,11.6 v 13.92 c 0,6.39595 -5.20405,11.6 -11.6,11.6 z"
            />
          <path
            class="books paper"
            d="m 141.05649,23.96 h -106.72 c -1.28122,0 -2.32,-1.03878 -2.32,-2.32 v 0 c 0,-1.28122 1.03878,-2.32 2.32,-2.32 h 106.72 z"
            />
          <path
            class="books paper"
            d="m 141.05649,33.24 h -106.72 c -1.28122,0 -2.32,-1.03878 -2.32,-2.32 v 0 c 0,-1.28122 1.03878,-2.32 2.32,-2.32 h 106.72 z"
            />
          <path
            class="books paper"
            d="m 141.05649,42.52 h -106.72 c -1.28122,0 -2.32,-1.03878 -2.32,-2.32 v 0 c 0,-1.28122 1.03878,-2.32 2.32,-2.32 h 106.72 z"
            />
          <path
            class="books paper"
            d="m 6.49649,61.08 h 120.64 c 1.28122,0 2.32,1.03878 2.32,2.32 v 0 c 0,1.28122 -1.03878,2.32 -2.32,2.32 h -120.64 c 0,0 0,-4.64 0,-4.64 z"
            />
          <path
            class="books paper"
            d="m 6.49649,70.36 h 120.64 c 1.28122,0 2.32,1.03878 2.32,2.32 v 0 c 0,1.28122 -1.03878,2.32 -2.32,2.32 h -120.64 c 0,0 0,-4.64 0,-4.64 z"
            />
          <path
            class="books paper"
            d="m 6.49649,79.64 h 120.64 c 1.28122,0 2.32,1.03878 2.32,2.32 v 0 c 0,1.28122 -1.03878,2.32 -2.32,2.32 h -120.64 c 0,0 0,-4.64 0,-4.64 z"
            />
          <path
            class="books top"
            d="M 143.44,51.8 H 32.08 C 24.40399,51.8 18.16,45.55601 18.16,37.88 V 19.32 C 18.16,11.64399 24.40399,5.4 32.08,5.4 h 111.36 c 2.56244,0 4.64,2.07756 4.64,4.64 0,2.56244 -2.07756,4.64 -4.64,4.64 H 32.08 c -2.55896,0 -4.64,2.08104 -4.64,4.64 v 18.56 c 0,2.5578 2.08104,4.64 4.64,4.64 h 111.36 c 2.56244,0 4.64,2.07756 4.64,4.64 0,2.56244 -2.07756,4.64 -4.64,4.64 z"
            />
          <path
            class="books paper"
            d="m 34.33649,130.68 c -1.28238,0 -2.32,1.03762 -2.32,2.32 0,1.28238 1.03762,2.32 2.32,2.32 h 106.72 v -4.64 z"
            />
          <path
            class="books paper"
            d="m 34.33649,121.4 c -1.28238,0 -2.32,1.03762 -2.32,2.32 0,1.28238 1.03762,2.32 2.32,2.32 h 106.72 v -4.64 z"
            />
          <path
            class="books paper"
            d="m 34.33649,112.12 c -1.28238,0 -2.32,1.03762 -2.32,2.32 0,1.28238 1.03762,2.32 2.32,2.32 h 106.72 v -4.64 z"
            />
          <path
            class="books paper"
            d="m 34.33649,102.84 c -1.28238,0 -2.32,1.03762 -2.32,2.32 0,1.28238 1.03762,2.32 2.32,2.32 h 106.72 v -4.64 z"
            />
        </svg>
        <div class="navTitle">Courses</div>
      </router-link>
      <router-link class="navBar" to="/joinus">
        <svg class="icon" viewBox="0 0 150 150">
          <path
            class="hand right"
            d="m 122.05453,72.999477 -3.77174,-30.63937 -7.06788,0.87 0.003,-0.0049 -13.702498,-7.71139 c -1.4616,-0.82244 -3.13896,-1.1803 -4.80907,-1.02602 l -21.63574,2.001 c -2.65959,0.24592 -5.03614,1.76349 -6.37797,4.07305 l -15.24936,26.24732 c -1.12607,1.93807 -0.24215,4.42366 1.85484,5.21565 l 0.62379,0.23548 c 1.20002,0.45327 2.43339,0.71572 3.66618,0.81838 l -1.93227,1.68287 -3.8657,3.368059 -10.99477,9.3786 c -1.95721,1.70491 -2.1605,4.67161 -0.45559,6.62882 l 1.11534,1.27745 c 2.1895,2.51082 6.00039,2.77153 8.51585,0.58145 l 4.2021,4.819804 c 1.36619,1.5689 3.36777,2.26287 5.29076,2.02623 1.15565,-0.1421 2.28317,-0.62118 3.2248,-1.44478 l 4.19746,4.82009 c 1.37112,1.57296 3.37241,2.26229 5.2954,2.02565 1.15565,-0.14239 2.28346,-0.61683 3.22538,-1.44014 l 2.28114,1.97142 c 2.19008,2.51517 6.00532,2.7753 8.52078,0.58522 l 3.10097,-2.70541 26.069838,-20.303484 0.0281,-0.02581 10.28572,-0.01015 z"
            />
          <path
            class="hand right shadow"
            d="m 110.8817,78.431176 -0.0281,0.02581 -26.069838,20.30348 -3.10097,2.705414 c -2.51517,2.19008 -6.3307,1.92995 -8.52078,-0.58522 l -2.28114,-1.971424 c -0.94192,0.82331 -2.07002,1.298044 -3.22538,1.440144 -1.92299,0.23664 -3.92399,-0.452694 -5.2954,-2.025654 l -4.19746,-4.82009 c -0.94192,0.82331 -2.06944,1.30239 -3.2248,1.44478 -1.92299,0.23664 -3.92457,-0.45704 -5.29076,-2.02623 l -4.2021,-4.8198 c -2.15354,1.87514 -5.25422,1.94822 -7.47649,0.35583 -1.1397,1.71854 -1.04864,4.04782 0.37207,5.67878 l 1.11534,1.27745 c 2.1895,2.51082 6.00039,2.77153 8.51585,0.58145 l 4.2021,4.819804 c 1.36619,1.5689 3.36777,2.26287 5.29076,2.02623 1.15565,-0.1421 2.28288,-0.62118 3.2248,-1.44478 l 4.19746,4.82038 c 1.37112,1.57296 3.37241,2.26229 5.2954,2.02565 1.15565,-0.14239 2.28346,-0.61683 3.22538,-1.44014 l 2.28114,1.97142 c 2.19008,2.51517 6.00532,2.7753 8.52078,0.58522 l 3.10097,-2.70541 26.069838,-20.303484 0.0281,-0.02581 10.28572,-0.01015 -1.13796,-9.24404 z"
            />
          <path
            class="hand left"
            d="m 115.629,91.684176 -13.96785,-12.0437 -3.884258,-3.346599 -2.77936,-2.39366 -11.95003,-10.3008 1.38011,-11.7479 c 0.4669,-3.97329 -2.03435,-7.69312 -5.89019,-8.76003 l -26.04925,-7.20795 c -2.75616,-0.7627 -5.66921,0.5162 -6.97305,3.06153 l -3.27584,6.3945 -14.06152,-0.95439 -3.6018,30.65996 -1.56542,13.324049 13.68742,0.91031 0.02842,0.02581 28.59458,24.647974 3.11605,2.6883 c 2.52735,2.17616 6.34114,1.89486 8.5173,-0.63249 l 4.1702,-4.83894 c 0.94627,0.81809 2.07698,1.28644 3.2335,1.42245 1.92415,0.2262 3.92167,-0.47444 5.28409,-2.05494 l 4.17078,-4.84329 c 0.94627,0.81809 2.0764,1.29108 3.23292,1.4268 1.92415,0.2262 3.921958,-0.47879 5.279448,-2.05552 l 4.17513,-4.843 c 2.52735,2.17616 6.33679,1.89428 8.51237,-0.628724 l 1.10838,-1.28383 c 1.69418,-1.9662 1.47436,-4.93174 -0.49213,-6.62592 z"
            />
          <path
            class="hand left shadow"
            d="m 115.629,91.684176 -4.25459,-3.6685 c 1.38272,1.83367 1.3543,4.44222 -0.20619,6.25356 l -1.17653,1.36271 c -2.30956,2.67815 -6.35332,2.97743 -9.0364,0.66729 l -4.432358,5.141124 c -1.44101,1.67359 -3.56178,2.42179 -5.60454,2.18196 -1.22757,-0.14413 -2.4273,-0.64612 -3.43186,-1.51467 l -4.42772,5.1417 c -1.44623,1.67765 -3.56642,2.42121 -5.60918,2.18138 -1.22757,-0.14413 -2.42788,-0.64148 -3.43244,-1.51003 l -4.42714,5.13706 c -0.83404,0.96889 -1.89631,1.62168 -3.03746,1.95808 l 1.88471,1.62603 c 2.52735,2.17616 6.34114,1.89486 8.5173,-0.63249 l 4.1702,-4.83894 c 0.94627,0.81809 2.07698,1.28644 3.2335,1.42245 1.92415,0.22591 3.92167,-0.47444 5.28409,-2.05494 l 4.17078,-4.84329 c 0.94627,0.81809 2.0764,1.29108 3.23292,1.4268 1.92415,0.2262 3.921958,-0.47879 5.279448,-2.05552 l 4.17513,-4.843 c 2.52735,2.17616 6.33679,1.89428 8.51237,-0.628724 l 1.10838,-1.28383 c 1.69389,-1.96649 1.47407,-4.93203 -0.49242,-6.62621 z"
            />
          <path
            class="hand left shadow"
            d="m 107.91471,98.610246 -7.65368,-6.59924 c -0.909148,-0.78416 -2.282878,-0.68266 -3.067618,0.22707 -0.78445,0.90973 -0.68266,2.28317 0.22707,3.06762 l 7.640048,6.587644 1.44014,-1.6704 c 0.57478,0.49503 1.21771,0.85608 1.8908,1.09939 0.49677,-0.88421 0.32074,-2.024494 -0.47676,-2.712084 z"
            />
          <path
            class="hand left shadow"
            d="m 95.677582,106.79144 c 0.52403,-0.88885 0.35612,-2.05146 -0.45298,-2.7492 l -6.87532,-5.927894 c -0.90973,-0.78416 -2.28288,-0.68266 -3.06762,0.22707 -0.78445,0.90973 -0.68266,2.283174 0.22707,3.067624 l 6.87532,5.92789 c 0.0029,0.002 0.0058,0.004 0.0087,0.007 l 1.42042,-1.64952 c 0.56637,0.48981 1.19973,0.85318 1.86441,1.09736 z"
            />
          <path
            class="hand right"
            d="m 37.411362,89.248756 -1.65677,2.18776 c -1.80409,2.38235 -1.33545,5.77622 1.0469,7.5806 v 0 c 2.38235,1.804094 5.77622,1.335454 7.5806,-1.0469 l 1.65677,-2.18776 c 1.80409,-2.38235 1.33545,-5.77622 -1.0469,-7.5806 v 0 c -2.38235,-1.80409 -5.77651,-1.33545 -7.5806,1.0469 z"
            />
          <path
            class="hand right"
            d="m 47.502202,93.850186 -3.12011,4.12003 c -1.80409,2.382354 -1.33545,5.776224 1.0469,7.580604 v 0 c 2.38235,1.80409 5.77622,1.33545 7.5806,-1.0469 l 3.12011,-4.12003 c 1.80409,-2.382354 1.33545,-5.776224 -1.0469,-7.580604 v 0 c -2.38264,-1.80409 -5.77651,-1.33545 -7.5806,1.0469 z"
            />
          <path
            class="hand right"
            d="m 57.261572,98.888936 -4.25227,5.614984 c -1.80409,2.38235 -1.33545,5.77622 1.0469,7.5806 v 0 c 2.38235,1.80409 5.77622,1.33545 7.5806,-1.0469 l 4.25227,-5.61498 c 1.80409,-2.38235 1.33545,-5.776224 -1.0469,-7.580604 v 0 c -2.38235,-1.80438 -5.77622,-1.33545 -7.5806,1.0469 z"
            />
          <path
            class="hand right"
            d="m 66.135862,105.09668 -4.49906,5.94065 c -1.80409,2.38235 -1.33545,5.77622 1.0469,7.5806 v 0 c 2.38235,1.80409 5.77622,1.33545 7.5806,-1.0469 l 4.49906,-5.94065 c 1.80409,-2.38235 1.33545,-5.77622 -1.0469,-7.5806 v 0 c -2.38264,-1.80409 -5.77651,-1.33545 -7.5806,1.0469 z"
            />
          <path
            class="hand right"
            d="m 111.21781,43.225177 -13.702498,-7.71139 c -1.4616,-0.82244 -3.13896,-1.1803 -4.80907,-1.02602 l -21.63574,2.001 c -2.65959,0.24592 -5.03614,1.76349 -6.37797,4.07305 l -15.24936,26.24732 c -1.12607,1.93836 -0.24215,4.42366 1.85484,5.21565 l 0.62379,0.23548 c 5.58975,2.1112 11.90247,0.31465 15.54284,-4.42308 l 5.84263,-7.6038 c 0,0 14.04441,16.26117 29.507208,-2.7289"
            />
          <path
            class="hand right sleeve"
            d="m 149.22376,90.411656 -7.16677,-58.217789 c -0.0705,-0.57246 -0.3654,-1.09359 -0.82012,-1.44855 -0.45472,-0.35496 -1.03153,-0.51446 -1.60428,-0.44428 l -16.75852,2.06306 c -4.35261,0.53592 -7.45764,4.51298 -6.92172,8.8653 l 5.75476,46.747999 c 0.49532,4.02433 3.93211,6.98204 7.888,6.98204 0.32248,0 0.64931,-0.01972 0.9773,-0.06003 l 16.75852,-2.06306 c 1.1919,-0.14703 2.03957,-1.2325 1.89283,-2.42469 z"
            />
          <path
            class="hand right sleeve shadow"
            d="m 149.22376,90.411656 -0.78677,-6.39044 c -0.3567,0.52345 -0.92626,0.89755 -1.60428,0.98107 l -17.56733,2.16253 c -0.34394,0.04234 -0.68643,0.06293 -1.02457,0.06293 -2.958,0 -5.63789,-1.57818 -7.12037,-4.0136 l 0.58638,4.76296 c 0.49532,4.02433 3.93211,6.98204 7.888,6.98204 0.32248,0 0.64931,-0.01972 0.9773,-0.06003 l 16.75852,-2.06306 c 1.19219,-0.14674 2.03986,-1.23221 1.89312,-2.4244 z"
            />
          <path
            class="hand left sleeve"
            d="m 27.125932,32.363807 -16.75852,-2.06306 c -0.5733298,-0.07047 -1.1495598,0.08932 -1.6042798,0.44428 -0.45472,0.35496 -0.74965,0.87609 -0.82012,1.44855 L 0.77624224,90.411656 c -0.14674,1.19219 0.70092996,2.27766 1.89282996,2.4244 l 16.7585198,2.06306 c 0.32828,0.04031 0.65453,0.06003 0.9773,0.06003 3.9556,0 7.39268,-2.958 7.888,-6.98204 l 5.75476,-46.747999 c 0.53592,-4.35232 -2.56911,-8.32938 -6.92172,-8.8653 z"
            />
          <path
            class="hand left sleeve shadow"
            d="m 0.77624224,90.411656 0.78676996,-6.39044 c 0.3567,0.52345 0.92626,0.89755 1.60428,0.98107 l 17.5673298,2.16253 c 0.34394,0.04234 0.68643,0.06293 1.02457,0.06293 2.958,0 5.63789,-1.57818 7.12037,-4.0136 l -0.58638,4.76296 c -0.49532,4.02433 -3.93211,6.98204 -7.888,6.98204 -0.32248,0 -0.64931,-0.01972 -0.9773,-0.06003 L 2.6693622,92.836056 c -1.19248,-0.14674 -2.03985996,-1.23221 -1.89311996,-2.4244 z"
            />
          <circle
            class="hand circle"
            cx="135.31972"
            cy="81.089897"
            r="4.2044201"
            />
          <circle
            class="hand circle"
            cx="14.444812"
            cy="81.089897"
            r="4.2044201"
            />
        </svg>
        <div class="navTitle">Join us</div>
      </router-link>
  </nav>  
</template>

<script>

export default {
  name: 'NavBar',
  props: {

  },
  data() {
    return {
      Current_Page: "HomePage"
    }
  }
}
</script>

<style scoped>
  @import './../assets/navbaricons.css';

.navMenu {
  display: flex;
  justify-content: space-around;
  /* Background-color: white; */
  background: none;
  margin: 1rem 0;
  position: sticky;
  top: 0;
  z-index: 1000;
}
/* Hidden for mobile */
.navTitle{
  display: none;
}
.navBar {
  font-family: 'Montserrat', sans-serif;
}
.router-link-exact-active{ 
  font-weight: 600;
  font-style: italic;
  border-bottom: 4px solid #CE0000;
}
A.navBar {
  margin: 0.25rem 0;
  flex-basis: 10%;
  text-align: center;
	text-decoration:none; 
  }
A.navBar:hover {
  FONT-WEIGHT: bold;
  FONT-STYLE: italic; 
  border-bottom: 4px solid #CE0000;
}

/* Styling for nav icons */
.icon{
  background-color: white; 
  border: solid red;
  border-width: 1vw;
  border-radius: 25%; 
  padding: 2px;
  width: 10vw; 
  height: 10vw;
  justify-self: center;
  align-self: center;
}

/* Default is mobile, change is for all other sizes */
@media all and (min-width: 700px)
{
  .navMenu{
    background-color: white;
  }
  .icon{
    border-width: 6px;
  }
  .heading{
    flex-flow: row nowrap;
  }
  .heading-title {
    order: 0;
  }
  .navTitle{
    display: block;
  }
  .icon{
    width: 50px;
    height: 50px;
  }
}

@media all and (min-width: 1000px)
{
  /* Grow text while screen is different sizes */
  .heading-title {
    font-size: 2.4vw;
  }
}

@media all and (min-width: 1200px)
{
  /* Stop text growth when max width is reached */
  .heading-title {
    font-size: 2em;
  }
}
</style>

